<template>
	<div class="auto-input-tag">
		<el-popover :width="480" trigger="click" popper-class="auto-input-tag__popover">
			<template #referer>
				<el-input-tag :model-value="modelValue" @input="handleTagInput" @before-enter="handleBeforeEnter"></el-input-tag>
			</template>
			<div class="select-list" v-loading="loading">
				<template v-for="(item, index) in itemList" :key="index">
					<div class="select-list__item">{{item}}</div>
				</template>
			</div>
		</el-popover>
	</div>
</template>

<script setup>
	import { post } from '@/utils/request.js'
	
	const props = defineProps({
		modelValue: { type: Array },
		fetchUrl: { type: String },
		beforeRender: { type: Function }
	})
	
	const emits = defineEmits(['update:modelValue'])
	
	const { modelValue, fetchUrl, beforeRender } = toRefs(props)
	
	const loading = ref(false)
	const itemList = ref([])
	
	const handleBeforeEnter = () => {
		loading.value = true
		post(fetchUrl.value).then(res => {
			loading.value = false
			if(res.code != 0) {
				return 
			}
			
			itemList.value = res.data 
		})
	}
	
	const handleTagInput = (v) => {
		emits('update:modelValue', v);
	}
</script>

<style lang="scss" scoped>
	.auto-input-tag {
		width: 100%;
		
	}
</style>